import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true }); // Initialize AOS with custom options
  }, []);
  
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="container mx-auto px-4 max-w-full">
      <div className="min-h-screen flex flex-col items-center justify-center p-5 mt-20 mb-5">
        <div
          className="relative bg-white p-10 rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out max-w-4xl w-full"
          data-aos="fade-up"
        >
          {/* 3D Floating Shadow */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-400 opacity-20 blur-lg -translate-y-6 -translate-x-6 rounded-3xl"></div>

          <div className="flex flex-col md:flex-row gap-12 relative z-10">
            <div className="md:w-1/2">
              <h1
                className="text-4xl md:text-6xl font-extrabold text-black leading-tight hover:translate-x-1 hover:translate-y-1 transition-transform duration-300"
                data-aos="zoom-in"
              >
                Let's work <br /> together.
              </h1>
            </div>
            <div className="md:w-1/2">
              <form className="space-y-6" data-aos="fade-left">
                {/* Full Name Input */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="full-name" className="text-sm font-medium text-gray-700">Full Name</label>
                  <input
                    type="text"
                    id="full-name"
                    name="full-name"
                    placeholder="Your Name"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  />
                </div>

                {/* Company Name Input */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="company-name" className="text-sm font-medium text-gray-700">Company Name</label>
                  <input
                    type="text"
                    id="company-name"
                    name="company-name"
                    placeholder="Ex. Tesla Inc"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  />
                </div>

                {/* Email Input */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700">Email*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="you@example.com"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  />
                </div>

                {/* Service Selection */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="service-required" className="text-sm font-medium text-gray-700">Service Required*</label>
                  <select
                    id="service-required"
                    name="service-required"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  >
                    <option>Select Your Service</option>
                    <option>Web Development</option>
                    <option>Mobile App Development</option>
                    <option>UI/UX Design</ option>
                  </select>
                </div>

                {/* Project Budget Selection */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="project-budget" className="text-sm font-medium text-gray-700">Project Budget*</label>
                  <select
                    id="project-budget"
                    name="project-budget"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  >
                    <option>Select Your Range</option>
                    <option>$1,000 - $5,000</option>
                    <option>$5,000 - $10,000</option>
                    <option>$10,000 - $20,000</option>
                  </select>
                </div>

                {/* Project Details Input */}
                <div className="flex flex-col space-y-2">
                  <label htmlFor="project-details" className="text-sm font-medium text-gray-700">Project Details*</label>
                  <textarea
                    id="project-details"
                    name="project-details"
                    rows="4"
                    placeholder="Tell us more about your idea"
                    className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition duration-300"
                  />
                </div>

                {/* Submit Button */}
                <div className="flex justify-center">
                  <Link to="/thanks-you">
                  <button
                    type="submit"
                    className="bg-indigo-500 text-white py-3 px-8 rounded-full shadow-lg hover:bg-indigo-600 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-transform duration-300"
                    data-aos="zoom-in-up"
                  >
                    Send Inquiry
                  </button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Contact Email Section */}
        <div className="mt-16 text-center" data-aos="fade-up">
          <p className="text-4xl font-bold">
            Drop us an email for <span className="text-gray-500">collaborations</span> or <span className="text-gray-500">career opportunities</span>.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-16 mt-8">
            <div>
              <a href="mailto:hello@agency.com" className="text-3xl underline">hello@agency.com</a>
              <p className="text-gray-500">Projects, queries, and more.</p>
            </div>
            <div>
              <a href="mailto:career@agency.com" className="text-3xl underline">career@agency.com</a>
              <p className="text-gray-500">Join our dynamic team.</p>
            </div>
          </div>
          <div className="mt-8">
            <button
              className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full text-xl shadow-lg hover:bg-yellow-500 transition duration-300"
              data-aos="zoom-in"
            >
              View open positions
            </button>
          </div>
        </div>

        {/* Locations Section */}
        <div className="p-8" data-aos="fade-up">
          <div className="text-4xl font-bold">
            <span className="text-3d" data-text="Find our">Find our</span>
            <span className="block text-gray-500 text-3d" data-text="Locations">Locations</span>
          </div>
          <div className="mt-12 space-y-12">
            {/* Bangladesh Location */}
            <div className="flex items-center justify-between border-b py-8" data-aos="fade-up-right">
              <div className="flex items-center">
                <div className="bg-gray-200 p-4 text-center shadow-lg rounded-full">
                  <div className="text-2xl"><i className="fas fa-sun"></i></div>
                  <div className="text-2xl font-bold">16:10</div>
                </div>
                <div className="ml-8">
                  <div className="text-2xl font-bold">Bangladesh</div>
                  <div className="text-gray-500 mt-2">ADDRESS</div>
                  <div>Joypurhat Tower, Block F, House 2-3, Main Road, Banasree, Rampura, Dhaka 1219</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-gray-500">CONTACT</div>
                <div>hello@musemind.agency</div>
                <div>+88-0964-260-1068</div>
              </div >
            </div>

            {/* India Location */}
            <div className="flex items-center justify-between border-b py-8" data-aos="fade-up-left">
              <div className="flex items-center">
                <div className="bg-gray-200 p-4 text-center shadow-lg rounded-full">
                  <div className="text-2xl"><i className="fas fa-sun"></i></div>
                  <div className="text-2xl font-bold">16:10</div>
                </div>
                <div className="ml-8">
                  <div className="text-2xl font-bold">India</div>
                  <div className="text-gray-500 mt-2">ADDRESS</div>
                  <div>New Delhi Street, Technohub 9th Floor, Unit 6, Gurugram, Haryana</div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-gray-500">CONTACT</div>
                <div>india@musemind.agency</div>
                <div>+91-1120-260-1089</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}